module.exports = __webpack_public_path__ + "img/day_in_the_life_police_officer.b4c3a89d.jpg";